import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Card.module.css';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  compact?: boolean;
}

export function Card({ children, compact = false, className = '', ...rest }: Props) {
  const cls = compact ? `${styles.card} ${styles.compact}` : styles.card;
  return (
    <div className={`${cls} ${className}`} {...rest}>
      {children}
    </div>
  );
}
